import { getEnabledPlanes } from '../../../shared/utils/products';

// Turns a flat list of tree leaf values (e.g. ["city-Ashburn", "country-USA"]) into the
// backend's expected `[{ city: "Ashburn,Chicago", country: "USA" }]` shape -- one object
// per plane, grouping by prefix and comma-joining same-prefix values. The region tree
// only ever emits `city-*` leaves today (see `useRegionTreeItems`'s `onlyLeafChecked`
// TreeSelects), but this stays generic over any `${key}-${value}` prefixed item.
const buildRegions = (items) => {
    const grouped = {};
    (items || []).forEach(item => {
        const dashIndex = item.indexOf('-');
        if (dashIndex === -1) return;
        const key = item.substring(0, dashIndex);
        const value = item.substring(dashIndex + 1);
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(value);
    });
    return [Object.fromEntries(
        Object.entries(grouped).map(([key, values]) => [key, values.join(',')]),
    )];
};

/**
 * Builds the `subscription` field of the POST /subscriptions body from `checkedProducts`
 * state. The backend replaces the subscriber's entire `subscription` document with
 * whatever is sent here (see `create_or_update_general_subscription` in
 * sase-statuspage-subscription-module), so unchecked/removed products are simply omitted
 * -- there is no separate per-product unsubscribe call. An entirely empty
 * `checkedProducts` (e.g. after removing the last product) correctly produces `{}`,
 * which clears all product subscriptions server-side.
 */
export const buildSubscriptionPayload = (checkedProducts, products) => {
    let payload = {};
    Object.keys(checkedProducts || {}).forEach(cp => {
        if (!checkedProducts[cp]?.checked) return;
        const productPayload = {};
        const product = products.find(p => p.product_type === cp);
        const enabledPlanes = getEnabledPlanes(product);
        const multiPlane = enabledPlanes.length >= 2;

        if (multiPlane) {
            enabledPlanes.forEach(([planeType]) => {
                if (checkedProducts[cp]?.[planeType]?.length > 0) {
                    productPayload[planeType] = { regions: buildRegions(checkedProducts[cp][planeType]) };
                }
            });
        } else if (checkedProducts[cp]?.regions?.length > 0) {
            const planeKey = enabledPlanes.length === 1 ? enabledPlanes[0][0] : 'control';
            productPayload[planeKey] = { regions: buildRegions(checkedProducts[cp].regions) };
        }

        payload = { ...payload, [cp]: productPayload };
    });
    return payload;
};

export default buildSubscriptionPayload;
